/**
 * 网站 UI 静态文案字典（中英文）。
 * 键为平铺点号分隔；值支持 {var} 插值（由 utils/site-lang.js 的 t() 替换）。
 * zh 值必须与模板原中文一致；新增文案需同步补充两个语言。
 */

export default {
  zh: {
    // ── 通用 ──────────────────────────────
    'common.home': '首页',
    'common.products': '产品',
    'common.allProducts': '全部产品',
    'common.viewAll': '查看全部',
    'common.viewDetails': '了解详情',
    'common.readArticle': '阅读文章',
    'common.more': '更多内容',
    'common.insight': '洞察',
    'common.news': '新闻',
    'common.readSuffix': '阅读',
    'common.contactUs': '联系我们',
    'common.findDealer': '查找授权门店',
    'common.backCases': '← 返回全部案例',
    'common.backColors': '← 返回颜色库',
    'common.backWarranty': '← 返回质保服务',
    'common.backInsights': '← 返回全部内容',

    // ── 导航 / 页头 ────────────────────────
    'nav.products': '产品',
    'nav.gallery': '实车案例',
    'nav.colors': '颜色',
    'nav.insights': '洞察',
    'nav.about': '关于',
    'nav.warranty': '质保服务',
    'nav.warrantyQuery': '质保查询',
    'nav.auth': '正品验证',
    'nav.storeQuery': '授权门店查询',
    'nav.policy': '质保政策',
    'nav.member': '会员中心',
    'nav.contact': '联系我们',
    'nav.home': '首页',
    'nav.menu': '菜单',
    'nav.mainNav': '主导航',
    'nav.megaIntro': '从漆面保护到个性定制，找到适合你的汽车表面方案。',
    'nav.viewAllOf': '查看全部 {name}',

    // ── 首页 ──────────────────────────────
    'home.heroTitle1': '守护你的爱车，',
    'home.heroTitle2': '表达你的风格。',
    'home.heroSub': '从漆面保护、车身改色到玻璃隔热，为车身外观与驾乘体验找到合适之选。',
    'home.heroAlt': '漆面保护实车效果',
    'home.heroContact': '联系我们',
    'home.heroExplore': '探索产品',
    'home.familiesTitle1': '五大产品家族，',
    'home.familiesTitle2': '覆盖车身每一处细节。',
    'home.featuredTitle': '代表性产品',
    'home.galleryTitle': '实车案例',
    'home.galleryAll': '全部案例',
    'home.aboutTitle': '为什么选择 Auto Care？',
    'home.aboutLink': '关于我们',
    'home.insightsTitle': '洞察与动态',
    'home.serviceTitle': '质保与支持',
    'home.serviceWarrantyTitle': '质保查询',
    'home.serviceWarrantyDesc': '输入车主邮箱并验证，查询名下产品质保状态与有效期。',
    'home.serviceAuthTitle': '正品验证',
    'home.serviceAuthDesc': '输入防伪码，验证产品真伪与授权批次。',
    'home.serviceStoreTitle': '授权门店查询',
    'home.serviceStoreDesc': '查询您附近的官方授权安装门店。',
    'home.serviceHelp': '需要帮助？',
    'home.contactTitle1': '让我们聊聊',
    'home.contactTitle2': '你的爱车。',
    'home.contactBook': '门店预约',
    'home.contactBookSub': '预约到店评估与产品咨询',
    'home.contactSales': '联系销售',
    'home.contactSalesSub': '获取产品报价与样品',
    'home.contactSupport': '售后支持',

    // ── 页脚 ──────────────────────────────
    'footer.brand': '品牌',
    'footer.about': '关于我们',
    'footer.insights': '洞察与新闻',
    'footer.dealers': '授权门店',
    'footer.contact': '联系我们',
    'footer.products': '产品',
    'footer.service': '服务',
    'footer.warranty': '质保政策',
    'footer.warrantyQuery': '质保查询',
    'footer.auth': '正品验证',
    'footer.storeQuery': '授权门店查询',
    'footer.contactCol': '联系',
    'footer.hours': '周一至周五 9:00 – 18:00',
    'footer.privacy': '隐私政策',
    'footer.terms': '使用条款',
    'footer.limitedWarranty': '有限产品质保',

    // ── 产品中心 / 分类 / 详情 ──────────────
    'products.title': '产品中心',
    'products.bannerDesc': '覆盖漆面保护、车身改色、玻璃隔热、专项防护与个性定制五大领域，每个系列都有明确的材料、效果与质保说明，帮助你做合适的选择。',
    'product.relatedInsights': '相关洞察',
    'product.enquiryTitle': '对{name}感兴趣？联系我们获取报价与样品。',
    'product.breadcrumb': '面包屑',
    'product.selectVariant': '选择型号',
    'product.requestQuote': '咨询报价',
    'product.effect': '产品效果',
    'product.advantages': '核心优势',
    'product.applications': '适用部位',
    'product.specs': '规格',
    'product.installation': '施工',
    'product.care': '养护',
    'product.cases': '实车案例',
    'product.allCases': '全部案例',
    'product.warranty': '产品质保',
    'product.viewPolicy': '查看质保政策',
    'product.related': '同系列产品',

    // ── 实车案例 ───────────────────────────
    'gallery.title': '实车案例',
    'gallery.bannerDesc': '浏览真实装贴案例，了解不同产品在车辆上的实际效果。案例按颜色、产品与车辆信息标注，方便对比。',
    'gallery.area': '施工区域',
    'gallery.color': '颜色',
    'gallery.vehicle': '车辆',
    'gallery.enquire': '咨询同款方案 ↗',
    'gallery.filters': '筛选',
    'gallery.filterColor': '颜色',
    'gallery.allColors': '全部颜色',
    'gallery.filterCategory': '产品族',
    'gallery.allProducts': '全部产品',
    'gallery.reset': '重置筛选',
    'gallery.empty': '没有匹配的案例，请调整筛选条件。',

    // ── 颜色库 ────────────────────────────
    'colors.title': '颜色库',
    'colors.bannerDesc': '从透明保护到高光改色，浏览不同颜色与表面效果的选择。颜色在屏幕上的呈现可能与实物存在差异，请以样片为准。',
    'colors.collection': '效果系列',
    'colors.family': '基础色系',
    'colors.code': '色号',
    'colors.disclaimer': '屏幕、拍摄、环境光和原车底色会影响视觉，请以实物样片为最终依据。',
    'colors.samples': '获取样片 ↗',
    'colors.sameColor': '同色案例',
    'colors.filters': '筛选',
    'colors.allCollections': '全部系列',
    'colors.allFamilies': '全部色系',
    'colors.reset': '重置筛选',
    'colors.empty': '没有匹配的颜色，请调整筛选条件。',

    // ── 洞察与新闻 ─────────────────────────
    'insights.title': '洞察与新闻',
    'insights.bannerDesc': '选购指南、技术解析与品牌动态，帮助你了解汽车保护与改色产品。',
    'insights.navAria': '内容分类',
    'insights.all': '全部',
    'insights.insight': '洞察',
    'insights.news': '新闻',
    'article.toc': '目录',
    'article.summary': '摘要',
    'article.related': '相关产品',
    'article.breadcrumb': '面包屑',

    // ── 关于 ──────────────────────────────
    'about.title': '关于我们',
    'about.bannerDesc': '自 2010 年以来，我们专注于漆面保护、颜色定制与玻璃护理，为每一辆车提供专业、可靠的表面方案。',
    'about.storyTitle': '从一家小店，到值得信赖的保护专家。',
    'about.storyP1': '2010 年，Auto Care 从一家小型护理工坊起步，如今已成长为区域内最受信赖的车辆保护专家之一。超过 15 年的经验、数千台车辆的施工记录，让我们对“保护”二字有了更深入的理解。',
    'about.storyP2': '我们的使命很简单：以行业领先的产品与严谨的施工标准，为每辆车提供最好的保护，同时让每位车主获得超出预期的服务体验。',
    'about.statYears': '年行业经验',
    'about.statYearsP': '自 2010 年深耕汽车表面保护领域，持续积累施工与产品经验。',
    'about.statCars': '台车辆保护',
    'about.statCarsP': '累计完成超过一万台车辆的装贴与护理服务。',
    'about.statTeam': '名专业技术师',
    'about.statTeamP': '经过严格培训与认证的施工团队，确保每一台车都按标准交付。',
    'about.valuesTitle': '我们坚持的原则。',
    'about.value1': '品质优先',
    'about.value1P': '每一道工序都遵循严苛标准，绝不以牺牲品质换取效率。',
    'about.value2': '客户为本',
    'about.value2P': '倾听需求、透明沟通，让每位车主清楚了解方案与预期效果。',
    'about.value3': '持续精进',
    'about.value3P': '紧跟行业趋势，持续升级产品、工艺与服务能力。',
    'about.ctaTitle': '准备好与我们合作了吗？',
    'about.ctaDesc': '联系我们的团队，获取报价或预约施工服务。',

    // ── 质保服务 ───────────────────────────
    'warranty.title': '质保服务',
    'warranty.bannerDesc': '查询产品质保、验证产品真伪、查找授权门店，获得售后支持。',
    'warranty.cardWarrantyTitle': '质保查询',
    'warranty.cardWarrantyDesc': '输入车主邮箱并验证，查询名下产品质保状态、审核进度与有效期。',
    'warranty.cardAuthTitle': '正品验证',
    'warranty.cardAuthDesc': '输入产品防伪码，验证产品真伪与授权批次。',
    'warranty.cardStoreTitle': '授权门店查询',
    'warranty.cardStoreDesc': '查询您附近的官方授权安装门店。',
    'warranty.policy': '质保政策',
    'warranty.viewFull': '查看完整质保条款',
    'warranty.supportTitle1': '需要帮助？',
    'warranty.supportTitle2': '联系我们。',
    'warranty.supportEmail': '支持邮箱',
    'warranty.supportHotline': '服务热线',
    'warranty.supportOnline': '在线留言',
    'warranty.supportOnlineP': '提交问题描述，我们会在 1-2 个工作日内回复',

    // ── 质保查询 / 正品验证 / 门店查询 ──────
    'wq.query.title': '质保查询',
    'wq.query.description': '输入车主邮箱并获取邮箱验证码，查询该邮箱名下的质保记录、审核状态与质保起止日期。',
    'wq.query.formTitle': '按车主邮箱查询',
    'wq.query.inputLabel': '车主邮箱',
    'wq.query.emailPlaceholder': '请输入车主邮箱',
    'wq.query.codeLabel': '邮箱验证码',
    'wq.query.codePlaceholder': '请输入 6 位验证码',
    'wq.query.sendCode': '发送验证码',
    'wq.query.resendIn': '{s}s 后重发',
    'wq.query.codeSent': '验证码已发送至邮箱，如未收到请检查垃圾邮件文件夹',
    'wq.query.button': '查询质保',
    'wq.query.tip': '验证码将发送至车主邮箱，验证通过后可查看该邮箱名下的全部质保记录。',
    'wq.query.resultTitle': '质保记录',
    'wq.query.empty': '该邮箱名下暂无质保记录',
    'wq.auth.title': '正品验证',
    'wq.auth.description': '输入产品防伪码，验证产品真伪与授权批次。',
    'wq.auth.formTitle': '按防伪码验证',
    'wq.auth.inputLabel': '产品防伪码',
    'wq.auth.placeholder': '例如：SN-AUTH-8842',
    'wq.auth.button': '开始验证',
    'wq.auth.tip': '正品产品首次验证会记录验证时间。',
    'wq.auth.resultTitle': '验证结果',
    'wq.store.title': '授权门店查询',
    'wq.store.description': '输入门店编号或门店名称，查询授权状态与授权产品范围。',
    'wq.store.formTitle': '按门店编号查询',
    'wq.store.inputLabel': '门店编号 / 名称',
    'wq.store.placeholder': '例如：SN-0001',
    'wq.store.button': '查询门店',
    'wq.store.tip': '也可以前往经销商页面浏览全部授权门店。',
    'wq.store.resultTitle': '门店信息',
    'wq.querying': '查询中…',
    'wq.demoTip': '当前为演示数据，接入后端 API 后将返回真实记录。',
    'wq.notFound': '未找到',
    'wq.notFoundDesc': '未找到与输入内容匹配的记录，请核对后重试。',
    'wq.placeholderHint': '输入{label}后点击查询，结果将显示在此处。',
    'wq.inputRequired': '请输入{label}',
    'wq.badge.authOk': '正品 · 首次验证通过',
    'wq.badge.storeOk': '授权有效',
    'wq.badge.success': '查询成功',
    'wq.status.active': '已生效',
    'wq.status.expired': '已过期',
    'wq.status.pending': '待审核',
    'wq.status.onHold': '暂缓审核',
    'wq.status.rejected': '已拒绝',
    'wq.status.cancelled': '已取消',
    'wq.row.product': '产品',
    'wq.row.batch': '批次',
    'wq.row.status': '状态',
    'wq.row.firstVerified': '首次验证时间',
    'wq.row.storeName': '门店名称',
    'wq.row.city': '所在城市',
    'wq.row.authStatus': '授权状态',
    'wq.row.expires': '授权有效期至',
    'wq.row.products': '授权产品',
    'wq.row.serialNo': '序列号',
    'wq.row.category': '产品类型',
    'wq.row.vehicle': '车辆',
    'wq.row.installStore': '安装门店',
    'wq.row.installDate': '安装日期',
    'wq.row.period': '质保起止',

    // ── 经销商 ────────────────────────────
    'dealers.title': '经销商',
    'dealers.bannerDesc': '查找您附近的官方授权安装门店，享受专业施工与官方质保。',
    'dealers.filterRegion': '按地区筛选',
    'dealers.allRegions': '全部地区',
    'dealers.searchPh': '搜索门店名称或城市',
    'dealers.search': '搜索',
    'dealers.reset': '重置',
    'dealers.city': '城市',
    'dealers.address': '地址',
    'dealers.phone': '电话',
    'dealers.services': '服务',
    'dealers.official': '官方授权',
    'dealers.partner': '合作门店',
    'dealers.contact': '联系门店',
    'dealers.empty': '没有匹配的门店，请调整筛选条件。',
    'dealers.becomeTitle': '成为授权经销商',
    'dealers.becomeDesc': '加入我们的专业安装网络，获得行业领先的产品与技术支持。',
    'dealers.apply': '申请合作',

    // ── 联系我们 ───────────────────────────
    'contact.title': '联系我们',
    'contact.bannerDesc': '获取报价、申请合作或咨询产品信息，欢迎与我们联系。',
    'contact.detailsTitle': '联系方式',
    'contact.hotline': '服务热线',
    'contact.email': '邮箱',
    'contact.address': '办公地址',
    'contact.hours': '工作时间',
    'contact.warrantyLink': '已有产品？查询质保',
    'contact.formTitle': '给我们留言',
    'contact.name': '姓名',
    'contact.namePh': '您的姓名',
    'contact.phone': '电话',
    'contact.phonePh': '您的联系电话',
    'contact.emailF': '邮箱',
    'contact.emailPh': '您的邮箱',
    'contact.subject': '主题',
    'contact.optQuote': '获取报价',
    'contact.optInquiry': '产品咨询',
    'contact.optWarranty': '质保问题',
    'contact.optDealer': '合作申请',
    'contact.optOther': '其他',
    'contact.message': '留言内容',
    'contact.messagePh': '请描述您的需求…',
    'contact.submit': '提交留言',
    'contact.submitting': '提交中…',
    'contact.consent': '提交即表示您同意我们按隐私政策处理上述信息。',
    'contact.errRequired': '请填写姓名与留言内容',
    'contact.okSubmitted': '留言已提交，我们会尽快与您联系',

    // ── 法务 ──────────────────────────────
    'legal.toc': '目录',
    'legal.overview': '概述',
    'legal.privacy.title': '隐私政策',
    'legal.privacy.description': '了解我们如何收集、使用与保护您的个人信息。',
    'legal.privacy.summary': '我们重视您的隐私，仅收集提供服务所必需的信息，并采取合理措施保护数据安全。',
    'legal.privacy.h1': '信息收集',
    'legal.privacy.t1': '我们可能收集您主动提供的联系方式、咨询内容以及网站访问时产生的必要日志信息（IP、浏览器、访问时间等），用于响应咨询、提供服务与改进体验。',
    'legal.privacy.h2': '信息使用',
    'legal.privacy.t2': '所收集信息仅用于与您沟通、处理订单与质保、发送产品与服务相关通知。未经您的同意，我们不会将个人信息出售或出租给第三方。',
    'legal.privacy.h3': '信息保护',
    'legal.privacy.t3': '我们采取行业通用的安全措施保护您的信息，防止未经授权的访问、披露或损毁。',
    'legal.privacy.h4': 'Cookie 与本地存储',
    'legal.privacy.t4': '网站可能使用本地存储记录语言偏好等基础设置，用于提升访问体验。您可通过浏览器设置管理。',
    'legal.privacy.h5': '您的权利',
    'legal.privacy.t5': '您有权查询、更正或删除我们持有的个人信息，可通过联系我们页面提交请求。',
    'legal.terms.title': '服务条款',
    'legal.terms.description': '使用本网站与购买产品前，请阅读以下条款。',
    'legal.terms.summary': '访问本网站即视为您同意遵守本服务条款；如不同意，请停止使用。',
    'legal.terms.h1': '产品说明',
    'legal.terms.t1': '网站所展示产品的颜色、纹理与效果受屏幕显示影响，可能与实物存在差异，请以实物样片为最终依据。',
    'legal.terms.h2': '质保条款',
    'legal.terms.t2': '质保范围与期限以随产品交付的质保卡及官方质保政策为准。未经授权门店施工或未按规定养护可能影响质保。',
    'legal.terms.h3': '知识产权',
    'legal.terms.t3': '网站内容、品牌标识、图片与文字均受知识产权法律保护，未经书面许可不得复制或商用。',
    'legal.terms.h4': '责任限制',
    'legal.terms.t4': '在法律允许的范围内，我们对因使用本网站或产品产生的间接损失不承担责任。',
    'legal.terms.h5': '条款变更',
    'legal.terms.t5': '我们可能适时更新本条款，更新后将在本页面发布，继续使用即视为接受更新后的条款。',

    // ── 会员 ──────────────────────────────
    'member.viewProof': '查看购买凭证',
    'member.proofTitle': '购买凭证',
    'member.noProof': '暂无购买凭证文件。',
    'member.download': '下载文件',
    'member.close': '关闭'
  },

  en: {
    // ── Common ────────────────────────────
    'common.home': 'Home',
    'common.products': 'Products',
    'common.allProducts': 'All Products',
    'common.viewAll': 'View All',
    'common.viewDetails': 'Learn More',
    'common.readArticle': 'Read Article',
    'common.more': 'More',
    'common.insight': 'Insight',
    'common.news': 'News',
    'common.readSuffix': 'read',
    'common.contactUs': 'Contact Us',
    'common.findDealer': 'Find a Dealer',
    'common.backCases': '← All Installations',
    'common.backColors': '← Color Library',
    'common.backWarranty': '← Warranty & Support',
    'common.backInsights': '← Back to Insights',

    // ── Nav / Header ──────────────────────
    'nav.products': 'Products',
    'nav.gallery': 'Installations',
    'nav.colors': 'Colors',
    'nav.insights': 'Insights',
    'nav.about': 'About',
    'nav.warranty': 'Warranty',
    'nav.warrantyQuery': 'Warranty Lookup',
    'nav.auth': 'Authentication',
    'nav.storeQuery': 'Find a Dealer',
    'nav.policy': 'Warranty Policy',
    'nav.member': 'Member',
    'nav.contact': 'Contact Us',
    'nav.home': 'Home',
    'nav.menu': 'Menu',
    'nav.mainNav': 'Main navigation',
    'nav.megaIntro': 'From paint protection to custom wraps, find the right surface solution for your car.',
    'nav.viewAllOf': 'View all {name}',

    // ── Home ──────────────────────────────
    'home.heroTitle1': 'Protect what you drive,',
    'home.heroTitle2': 'express your style.',
    'home.heroSub': 'From paint protection and color wraps to window tint — the right choice for your car’s look and driving experience.',
    'home.heroAlt': 'Paint protection result on a real car',
    'home.heroContact': 'Contact Us',
    'home.heroExplore': 'Explore Products',
    'home.familiesTitle1': 'Five product families,',
    'home.familiesTitle2': 'covering every detail of your car.',
    'home.featuredTitle': 'Featured Products',
    'home.galleryTitle': 'Installations',
    'home.galleryAll': 'All Cases',
    'home.aboutTitle': 'Why Auto Care?',
    'home.aboutLink': 'About Us',
    'home.insightsTitle': 'Insights & News',
    'home.serviceTitle': 'Service & Support',
    'home.serviceWarrantyTitle': 'Warranty Lookup',
    'home.serviceWarrantyDesc': 'Enter your owner email to check warranty status and validity of your products.',
    'home.serviceAuthTitle': 'Authentication',
    'home.serviceAuthDesc': 'Enter the security code to verify authenticity and batch.',
    'home.serviceStoreTitle': 'Find a Dealer',
    'home.serviceStoreDesc': 'Find official authorized installers near you.',
    'home.serviceHelp': 'Need help?',
    'home.contactTitle1': 'Let’s talk about',
    'home.contactTitle2': 'your car.',
    'home.contactBook': 'Book a Visit',
    'home.contactBookSub': 'Book an in-store assessment and product consultation',
    'home.contactSales': 'Talk to Sales',
    'home.contactSalesSub': 'Request a quote and samples',
    'home.contactSupport': 'After-sales Support',

    // ── Footer ────────────────────────────
    'footer.brand': 'Brand',
    'footer.about': 'About Us',
    'footer.insights': 'Insights & News',
    'footer.dealers': 'Dealers',
    'footer.contact': 'Contact Us',
    'footer.products': 'Products',
    'footer.service': 'Service',
    'footer.warranty': 'Warranty Policy',
    'footer.warrantyQuery': 'Warranty Lookup',
    'footer.auth': 'Authentication',
    'footer.storeQuery': 'Find a Dealer',
    'footer.contactCol': 'Contact',
    'footer.hours': 'Mon–Fri 9:00 – 18:00',
    'footer.privacy': 'Privacy Policy',
    'footer.terms': 'Terms of Use',
    'footer.limitedWarranty': 'Limited Product Warranty',

    // ── Products / Category / Detail ──────
    'products.title': 'Products',
    'products.bannerDesc': 'Five families — paint protection, color wraps, window tint, specialty protection and custom graphics. Every series comes with clear materials, effects and warranty details to help you choose.',
    'product.relatedInsights': 'Related Insights',
    'product.enquiryTitle': 'Interested in {name}? Contact us for a quote and samples.',
    'product.breadcrumb': 'Breadcrumb',
    'product.selectVariant': 'Select Model',
    'product.requestQuote': 'Request a Quote',
    'product.effect': 'Effect',
    'product.advantages': 'Key Benefits',
    'product.applications': 'Applications',
    'product.specs': 'Specifications',
    'product.installation': 'Installation',
    'product.care': 'Care',
    'product.cases': 'Installations',
    'product.allCases': 'All Cases',
    'product.warranty': 'Product Warranty',
    'product.viewPolicy': 'View Warranty Policy',
    'product.related': 'Related Products',

    // ── Gallery ───────────────────────────
    'gallery.title': 'Installation Gallery',
    'gallery.bannerDesc': 'Browse real installations and see how each product looks on actual vehicles. Cases are tagged by color, product and vehicle for easy comparison.',
    'gallery.area': 'Area',
    'gallery.color': 'Color',
    'gallery.vehicle': 'Vehicle',
    'gallery.enquire': 'Enquire ↗',
    'gallery.filters': 'Filters',
    'gallery.filterColor': 'Color',
    'gallery.allColors': 'All Colors',
    'gallery.filterCategory': 'Product Family',
    'gallery.allProducts': 'All Products',
    'gallery.reset': 'Reset Filters',
    'gallery.empty': 'No matching cases. Please adjust your filters.',

    // ── Colors ────────────────────────────
    'colors.title': 'Color Library',
    'colors.bannerDesc': 'From transparent protection to glossy color change — browse colors and finishes. On-screen colors may differ from the actual film; samples prevail.',
    'colors.collection': 'Collection',
    'colors.family': 'Family',
    'colors.code': 'Code',
    'colors.disclaimer': 'Screens, photography, ambient light and the original paint can affect appearance. Physical samples prevail.',
    'colors.samples': 'Request Samples ↗',
    'colors.sameColor': 'Same Color Cases',
    'colors.filters': 'Filters',
    'colors.allCollections': 'All Collections',
    'colors.allFamilies': 'All Families',
    'colors.reset': 'Reset Filters',
    'colors.empty': 'No matching colors. Please adjust your filters.',

    // ── Insights & News ───────────────────
    'insights.title': 'Insights & News',
    'insights.bannerDesc': 'Buying guides, technical breakdowns and brand updates to help you understand protection and wrap products.',
    'insights.navAria': 'Content categories',
    'insights.all': 'All',
    'insights.insight': 'Insight',
    'insights.news': 'News',
    'article.toc': 'Contents',
    'article.summary': 'Summary',
    'article.related': 'Related Products',
    'article.breadcrumb': 'Breadcrumb',

    // ── About ─────────────────────────────
    'about.title': 'About Us',
    'about.bannerDesc': 'Since 2010, we have focused on paint protection, color customization and window care — professional, reliable surface solutions for every car.',
    'about.storyTitle': 'From a small shop to a protection specialist you can trust.',
    'about.storyP1': 'Auto Care started as a small care workshop in 2010 and has grown into one of the most trusted vehicle protection specialists in the region. 15+ years of experience and thousands of installations have given us a deeper understanding of “protection”.',
    'about.storyP2': 'Our mission is simple: industry-leading products and rigorous installation standards to give every car the best protection, and every owner an experience beyond expectations.',
    'about.statYears': 'Years of Experience',
    'about.statYearsP': 'Deep in automotive surface protection since 2010, continuously building installation and product expertise.',
    'about.statCars': 'Vehicles Protected',
    'about.statCarsP': 'Over ten thousand vehicles wrapped and cared for in total.',
    'about.statTeam': 'Certified Installers',
    'about.statTeamP': 'A strictly trained and certified team — every car delivered to standard.',
    'about.valuesTitle': 'What we stand for.',
    'about.value1': 'Quality First',
    'about.value1P': 'Every step follows strict standards — never trade quality for speed.',
    'about.value2': 'Customer First',
    'about.value2P': 'Listen, communicate transparently, and make sure every owner understands the plan and expected results.',
    'about.value3': 'Always Improving',
    'about.value3P': 'Keep up with industry trends and continuously upgrade products, craftsmanship and service.',
    'about.ctaTitle': 'Ready to work with us?',
    'about.ctaDesc': 'Contact our team for a quote or to book installation service.',

    // ── Warranty ──────────────────────────
    'warranty.title': 'Warranty & Support',
    'warranty.bannerDesc': 'Check product warranty, verify authenticity and find authorized dealers — get the support you need.',
    'warranty.cardWarrantyTitle': 'Warranty Lookup',
    'warranty.cardWarrantyDesc': 'Enter your owner email to check warranty status, review progress and validity.',
    'warranty.cardAuthTitle': 'Authentication',
    'warranty.cardAuthDesc': 'Enter the product security code to verify authenticity and authorized batch.',
    'warranty.cardStoreTitle': 'Find a Dealer',
    'warranty.cardStoreDesc': 'Find official authorized installation stores near you.',
    'warranty.policy': 'Warranty Policy',
    'warranty.viewFull': 'View Full Warranty Terms',
    'warranty.supportTitle1': 'Need help?',
    'warranty.supportTitle2': 'Contact us.',
    'warranty.supportEmail': 'Support Email',
    'warranty.supportHotline': 'Hotline',
    'warranty.supportOnline': 'Leave a Message',
    'warranty.supportOnlineP': 'Describe your issue — we reply within 1–2 business days',

    // ── Warranty Lookup / Auth / Store ────
    'wq.query.title': 'Warranty Lookup',
    'wq.query.description': 'Enter your owner email and verification code to view warranty records, review status and coverage dates under this email.',
    'wq.query.formTitle': 'Lookup by Owner Email',
    'wq.query.inputLabel': 'Owner Email',
    'wq.query.emailPlaceholder': 'Enter your email',
    'wq.query.codeLabel': 'Email Verification Code',
    'wq.query.codePlaceholder': 'Enter the 6-digit code',
    'wq.query.sendCode': 'Send Code',
    'wq.query.resendIn': 'Resend in {s}s',
    'wq.query.codeSent': 'Code sent. If you do not receive it, please check your spam folder.',
    'wq.query.button': 'Lookup',
    'wq.query.tip': 'A code will be sent to the owner email. Only records under this email are shown after verification.',
    'wq.query.resultTitle': 'Warranty Records',
    'wq.query.empty': 'No warranty records under this email',
    'wq.auth.title': 'Authentication',
    'wq.auth.description': 'Enter the product security code to verify authenticity and authorized batch.',
    'wq.auth.formTitle': 'Verify by Security Code',
    'wq.auth.inputLabel': 'Product Security Code',
    'wq.auth.placeholder': 'E.g. SN-AUTH-8842',
    'wq.auth.button': 'Verify',
    'wq.auth.tip': 'A first successful verification is timestamped for genuine products.',
    'wq.auth.resultTitle': 'Verification Result',
    'wq.store.title': 'Dealer Lookup',
    'wq.store.description': 'Enter a store number or name to check authorization status and covered products.',
    'wq.store.formTitle': 'Lookup by Store No.',
    'wq.store.inputLabel': 'Store No. / Name',
    'wq.store.placeholder': 'E.g. SN-0001',
    'wq.store.button': 'Search',
    'wq.store.tip': 'You can also browse all authorized dealers on the Dealers page.',
    'wq.store.resultTitle': 'Store Information',
    'wq.querying': 'Searching…',
    'wq.demoTip': 'Demo data — real records will be returned once the backend API is connected.',
    'wq.notFound': 'Not Found',
    'wq.notFoundDesc': 'No record matched your input. Please check and try again.',
    'wq.placeholderHint': 'Enter the {label} and click search — results will appear here.',
    'wq.inputRequired': 'Please enter the {label}',
    'wq.badge.authOk': 'Genuine · First Verification Passed',
    'wq.badge.storeOk': 'Authorized',
    'wq.badge.success': 'Found',
    'wq.status.active': 'Active',
    'wq.status.expired': 'Expired',
    'wq.status.pending': 'Pending Review',
    'wq.status.onHold': 'On Hold',
    'wq.status.rejected': 'Rejected',
    'wq.status.cancelled': 'Cancelled',
    'wq.row.product': 'Product',
    'wq.row.batch': 'Batch',
    'wq.row.status': 'Status',
    'wq.row.firstVerified': 'First Verified At',
    'wq.row.storeName': 'Store Name',
    'wq.row.city': 'City',
    'wq.row.authStatus': 'Authorization',
    'wq.row.expires': 'Authorized Until',
    'wq.row.products': 'Authorized Products',
    'wq.row.serialNo': 'Serial No.',
    'wq.row.category': 'Product Type',
    'wq.row.vehicle': 'Vehicle',
    'wq.row.installStore': 'Installed At',
    'wq.row.installDate': 'Install Date',
    'wq.row.period': 'Warranty Period',

    // ── Dealers ───────────────────────────
    'dealers.title': 'Dealers',
    'dealers.bannerDesc': 'Find official authorized installation stores near you — professional installation with official warranty.',
    'dealers.filterRegion': 'Filter by Region',
    'dealers.allRegions': 'All Regions',
    'dealers.searchPh': 'Search store name or city',
    'dealers.search': 'Search',
    'dealers.reset': 'Reset',
    'dealers.city': 'City',
    'dealers.address': 'Address',
    'dealers.phone': 'Phone',
    'dealers.services': 'Services',
    'dealers.official': 'Authorized',
    'dealers.partner': 'Partner',
    'dealers.contact': 'Contact Store',
    'dealers.empty': 'No matching stores. Please adjust your filters.',
    'dealers.becomeTitle': 'Become a Dealer',
    'dealers.becomeDesc': 'Join our professional installation network with industry-leading products and technical support.',
    'dealers.apply': 'Apply Now',

    // ── Contact ───────────────────────────
    'contact.title': 'Contact Us',
    'contact.bannerDesc': 'Request a quote, apply for partnership or ask about products — we’d love to hear from you.',
    'contact.detailsTitle': 'Contact',
    'contact.hotline': 'Hotline',
    'contact.email': 'Email',
    'contact.address': 'Office Address',
    'contact.hours': 'Business Hours',
    'contact.warrantyLink': 'Already a customer? Check warranty',
    'contact.formTitle': 'Send a Message',
    'contact.name': 'Name',
    'contact.namePh': 'Your name',
    'contact.phone': 'Phone',
    'contact.phonePh': 'Your phone number',
    'contact.emailF': 'Email',
    'contact.emailPh': 'Your email',
    'contact.subject': 'Subject',
    'contact.optQuote': 'Request a Quote',
    'contact.optInquiry': 'Product Inquiry',
    'contact.optWarranty': 'Warranty Question',
    'contact.optDealer': 'Dealer Application',
    'contact.optOther': 'Other',
    'contact.message': 'Message',
    'contact.messagePh': 'Tell us what you need…',
    'contact.submit': 'Send Message',
    'contact.submitting': 'Sending…',
    'contact.consent': 'By submitting, you agree that we process the information above per our Privacy Policy.',
    'contact.errRequired': 'Please fill in your name and message',
    'contact.okSubmitted': 'Message sent — we will get back to you soon',

    // ── Legal ─────────────────────────────
    'legal.toc': 'Contents',
    'legal.overview': 'Overview',
    'legal.privacy.title': 'Privacy Policy',
    'legal.privacy.description': 'Learn how we collect, use and protect your personal information.',
    'legal.privacy.summary': 'We value your privacy, collect only what is necessary to provide our services, and take reasonable measures to keep data safe.',
    'legal.privacy.h1': 'Information We Collect',
    'legal.privacy.t1': 'We may collect contact details and enquiry content you provide, plus necessary logs (IP, browser, visit time) to respond to enquiries, provide services and improve experience.',
    'legal.privacy.h2': 'How We Use It',
    'legal.privacy.t2': 'Collected information is used only to communicate with you, process orders and warranties, and send product or service notices. We never sell or rent personal information to third parties without consent.',
    'legal.privacy.h3': 'Data Protection',
    'legal.privacy.t3': 'We adopt industry-standard security measures to protect your information from unauthorized access, disclosure or destruction.',
    'legal.privacy.h4': 'Cookies & Local Storage',
    'legal.privacy.t4': 'The site may use local storage for basic settings such as language preference. You can manage this in your browser settings.',
    'legal.privacy.h5': 'Your Rights',
    'legal.privacy.t5': 'You have the right to access, correct or delete your personal information — submit a request via the contact page.',
    'legal.terms.title': 'Terms of Service',
    'legal.terms.description': 'Please read the following terms before using this website or purchasing products.',
    'legal.terms.summary': 'Accessing this website means you agree to these terms; if you disagree, please stop using it.',
    'legal.terms.h1': 'Product Descriptions',
    'legal.terms.t1': 'Colors, textures and effects shown on the website may differ from the actual product due to screen display. Physical samples prevail.',
    'legal.terms.h2': 'Warranty Terms',
    'legal.terms.t2': 'Warranty scope and period are governed by the warranty card delivered with the product and the official warranty policy. Installation by unauthorized stores or improper care may void the warranty.',
    'legal.terms.h3': 'Intellectual Property',
    'legal.terms.t3': 'Website content, brand marks, images and text are protected by intellectual property laws and may not be copied or used commercially without written permission.',
    'legal.terms.h4': 'Limitation of Liability',
    'legal.terms.t4': 'To the extent permitted by law, we are not liable for indirect losses arising from use of this website or products.',
    'legal.terms.h5': 'Changes to Terms',
    'legal.terms.t5': 'We may update these terms from time to time; updates are posted on this page and continued use constitutes acceptance.',

    // ── Member ────────────────────────────
    'member.viewProof': 'View Proof of Purchase',
    'member.proofTitle': 'Proof of Purchase',
    'member.noProof': 'No proof of purchase files.',
    'member.download': 'Download file',
    'member.close': 'Close'
  }
}
